var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-text"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6490",
    "data-name": "Rectangle 6490",
    width: 49,
    height: 49,
    fill: "#d7b16d",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239624",
    "data-name": "Path 239624",
    d: "M22.292,16H10.042a2.042,2.042,0,1,0,0,4.083h12.25a2.042,2.042,0,1,0,0-4.083Z",
    transform: "translate(8.333 16.667)",
    fill: "#d7b16d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239625",
    "data-name": "Path 239625",
    d: "M10.042,16.083h6.125a2.042,2.042,0,1,0,0-4.083H10.042a2.042,2.042,0,0,0,0,4.083Z",
    transform: "translate(8.333 12.5)",
    fill: "#d7b16d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239626",
    "data-name": "Path 239626",
    d: "M36.136,14.924,25.029,2.674A2.042,2.042,0,0,0,23.518,2H9.227A5.165,5.165,0,0,0,4,7.1V37.729a5.165,5.165,0,0,0,5.227,5.1H31.44a5.165,5.165,0,0,0,5.227-5.1V16.292a2.042,2.042,0,0,0-.531-1.368Zm-11.719-6.8,5.594,6.125H25.928a1.613,1.613,0,0,1-1.511-1.735ZM31.44,38.75H9.227a1.082,1.082,0,0,1-1.143-1.021V7.1A1.082,1.082,0,0,1,9.227,6.084H20.333v6.431a5.7,5.7,0,0,0,5.533,5.819h6.717v19.4A1.082,1.082,0,0,1,31.44,38.75Z",
    transform: "translate(4.167 2.083)",
    fill: "#d7b16d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.3c1d1f07f799aae7119736f080e2a7ba.svg";
export { ForwardRef as ReactComponent };